// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2-ovb","resendInfoText":"OnGoingPaymentBox_resendInfoText__vJ7PH"};